/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export class DealerwareSolrSearchArgs implements IDealerwareSolrSearchArgs {
        //properties
        // ----------------------------------------------------

        private _locationId     :   number;
        private _active         :   boolean;
        private _live           :   boolean;
        private _live_type      :   string;
        private _unsettled      :   boolean;
        private _include_inactive:  boolean;
        private _sortBy         :   string;
        private _sortDirection  :   string;

        public static $inject: string[] = [];
        public searchArgs : any;

        // constructor
        // ----------------------------------------------------
        constructor() {
            this.clear();
        }

        // accessors
        // ----------------------------------------------------
        public get locationId() : number {
            return this._locationId;
        }

        public set locationId(locationId: number) {
            this._locationId = locationId;
        }

        public get active() : boolean {
            return this._active;
        }

        public set active(active: boolean) {
            this._active = active;
        }

        public get live() : boolean {
            return this._live;
        }

        public set live(live: boolean) {
            this._live = live;
        }

        public get live_type() : string {
            return this._live_type;
        }

        public set live_type(live_type: string) {
            this._live_type = live_type;
        }

        public get unsettled() : boolean {
            return this._unsettled;
        }

        public set unsettled(unsettled: boolean) {
            this._unsettled = unsettled;
        }

        public get include_inactive() : boolean {
            return this._include_inactive;
        }

        public set include_inactive(include_inactive: boolean) {
            this._include_inactive = include_inactive;
        }

        public get sortBy() : string {
            return this._sortBy;
        }

        public set sortBy(sortBy : string) {
            this._sortBy = sortBy;
        }

        public get sortDirection() : string {
            return this._sortDirection;
        }

        public set sortDirection(direction : string) {
            this._sortDirection = direction;
            if (direction && !((direction == 'asc') || (direction == 'desc')) ) {
                throw "Invalid sort direction";
            }
        }

        // methods
        // ----------------------------------------------------

        public get searchText() : string {
            return this.searchArgs.search_text;
        }

        public set searchText(t : string) {
            this.searchArgs.search_text = t;
        }

        public clear() : void {
            this.searchArgs = {
                search_text: undefined
            };
        }
    }

    getDealerwareWebServicesModule().service("dealerwareSolrSearchArgs", DealerwareSolrSearchArgs);
}